import _defineProperty from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// source: https://en.wikipedia.org/wiki/Note_value
var DATA = [[0.125, "dl", ["large", "duplex longa", "maxima", "octuple", "octuple whole"]], [0.25, "l", ["long", "longa"]], [0.5, "d", ["double whole", "double", "breve"]], [1, "w", ["whole", "semibreve"]], [2, "h", ["half", "minim"]], [4, "q", ["quarter", "crotchet"]], [8, "e", ["eighth", "quaver"]], [16, "s", ["sixteenth", "semiquaver"]], [32, "t", ["thirty-second", "demisemiquaver"]], [64, "sf", ["sixty-fourth", "hemidemisemiquaver"]], [128, "h", ["hundred twenty-eighth"]], [256, "th", ["two hundred fifty-sixth"]]];
var VALUES = [];
DATA.forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 3),
      denominator = _ref2[0],
      shorthand = _ref2[1],
      names = _ref2[2];

  return add(denominator, shorthand, names);
});
var NoDuration = {
  empty: true,
  name: "",
  value: 0,
  fraction: [0, 0],
  shorthand: "",
  dots: "",
  names: []
};

function names() {
  return VALUES.reduce(function (names, duration) {
    duration.names.forEach(function (name) {
      return names.push(name);
    });
    return names;
  }, []);
}

function shorthands() {
  return VALUES.map(function (dur) {
    return dur.shorthand;
  });
}

var REGEX = /^([^.]+)(\.*)$/;

function get(name) {
  var _ref3 = REGEX.exec(name) || [],
      _ref4 = _slicedToArray(_ref3, 3),
      _ = _ref4[0],
      simple = _ref4[1],
      dots = _ref4[2];

  var base = VALUES.find(function (dur) {
    return dur.shorthand === simple || dur.names.includes(simple);
  });

  if (!base) {
    return NoDuration;
  }

  var fraction = calcDots(base.fraction, dots.length);
  var value = fraction[0] / fraction[1];
  return _objectSpread(_objectSpread({}, base), {}, {
    name: name,
    dots: dots,
    value: value,
    fraction: fraction
  });
}

var value = function value(name) {
  return get(name).value;
};

var fraction = function fraction(name) {
  return get(name).fraction;
};

var index = {
  names: names,
  shorthands: shorthands,
  get: get,
  value: value,
  fraction: fraction
}; //// PRIVATE ////

function add(denominator, shorthand, names) {
  VALUES.push({
    empty: false,
    dots: "",
    name: "",
    value: 1 / denominator,
    fraction: denominator < 1 ? [1 / denominator, 1] : [1, denominator],
    shorthand: shorthand,
    names: names
  });
}

function calcDots(fraction, dots) {
  var pow = Math.pow(2, dots);
  var numerator = fraction[0] * pow;
  var denominator = fraction[1] * pow;
  var base = numerator; // add fractions

  for (var i = 0; i < dots; i++) {
    numerator += base / Math.pow(2, i + 1);
  } // simplify


  while (numerator % 2 === 0 && denominator % 2 === 0) {
    numerator /= 2;
    denominator /= 2;
  }

  return [numerator, denominator];
}

export default index;
export { fraction, get, names, shorthands, value };